/* Taylor & Bennett redesign helpers */
(function () {
  /* Product page, mobile: start with all info accordions (Free shipping, Returns, Size) closed */
  function closeProductAccordions() {
    if (!window.matchMedia('(max-width: 999px)').matches) return;
    document.querySelectorAll('.shopify-section--product-content button[is="toggle-button"][aria-expanded="true"]').forEach(function (btn) {
      btn.click();
    });
  }
  if (document.readyState === 'complete') { closeProductAccordions(); }
  else { window.addEventListener('load', closeProductAccordions); }
})();
